import Toast from 'components/Toast/Toast';
import React, { createContext, useContext, useState } from 'react';

const ToastMessageContext = createContext();

const toastTime = 10000;

export const ToastMessageProvider = ({ children }) => {
	const [toasts, setToasts] = useState([]);

	const showToast = (message, status, time = 10000) => {
		const newToast = {
			id: Date.now(),
			message,
			status,
		};

		setToasts(prevToasts => [...prevToasts, newToast]);

		setTimeout(() => {
			setToasts(prevToasts =>
				prevToasts.filter(toast => toast.id !== newToast.id)
			);
		}, time + 500);
	};

	return (
		<ToastMessageContext.Provider value={{ toastTime, toasts, showToast }}>
			{children}
			{toasts.map(toast => (
				<Toast
					key={toast.id}
					message={toast.message}
					status={toast.status}
					time={toastTime}
				/>
			))}
		</ToastMessageContext.Provider>
	);
};

export const useToastMessageContext = () => {
	return useContext(ToastMessageContext);
};
